import React from 'react';

import PurchaseAvailable from './purchaseAvailable';
import PurchaseUnavailable from './purchaseUnavailable';
import PurchaseSectionSkeleton from './purchaseUnavailable/skeleton';

import { AcademicCourseEnrollmentStatus, CourseDetailEntity } from '@redux/course/type/courseDetailType';

type PurchaseSectionType = {
  name: string;
  idName: string;
  price: CourseDetailEntity['price'];
  enrollmentStatus: AcademicCourseEnrollmentStatus;
  gtmContentId: string;
  examExpiredAt?: Date;
  isUnAvailable?: boolean;
  isUnPurchase?: boolean;
  isEnrolled?: boolean;
  courseDetailData: CourseDetailEntity;
  isCourseDetailLoading: boolean;
};

const PurchaseSection = ({
  name,
  idName,
  enrollmentStatus,
  price,
  gtmContentId,
  examExpiredAt,
  isEnrolled,
  isUnAvailable,
  isUnPurchase,
  courseDetailData,
  isCourseDetailLoading,
}: PurchaseSectionType) => {
  if (isCourseDetailLoading) {
    return <PurchaseSectionSkeleton />;
  }

  return isUnAvailable ? (
    <PurchaseUnavailable
      idName={idName}
      isUnPurchase={isUnPurchase}
      isEnrolled={isEnrolled}
      enrollmentStatus={enrollmentStatus}
      examExpiredAt={examExpiredAt}
      price={price}
    />
  ) : (
    <PurchaseAvailable
      name={name}
      idName={idName}
      enrollmentStatus={enrollmentStatus}
      examExpiredAt={examExpiredAt}
      price={price}
      gtmContentId={gtmContentId}
      courseDetailData={courseDetailData}
    />
  );
};

export default PurchaseSection;
